import React, { useCallback, useEffect, useRef } from "react";
import { IconProps } from "../../models/icon";
import styles from "./Icon.module.scss";

const Icon = ({ url, className = "", height = 24, width = 24, withFillColor = true, withStrokeColor = false }: IconProps) => {
  const svgRef = useRef<HTMLDivElement>(null);

  function getSvgFromHtml(html: string) {
    const domParser = new DOMParser();
    const document = domParser.parseFromString(html, "text/html");

    return document.querySelector("svg");
  }

  const loadIcon = useCallback(
    async (url: string) => {
      try {
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error("Failed to fetch icon");
        }

        const html = await response.text();
        const svgElement = getSvgFromHtml(html);

        if (svgElement) {
          if (withFillColor) {
            svgElement.setAttribute("fill", "currentColor");
          }

          if (withStrokeColor) {
            svgElement.setAttribute("stroke", "currentColor");
          }

          svgElement.setAttribute("height", height.toString());
          svgElement.setAttribute("width", width.toString());

          if (svgRef && svgRef.current) {
            svgRef.current.appendChild(svgElement);
          }
        }
      } catch (error) {
        console.debug(error);
      }
    },
    [height, width, withFillColor, withStrokeColor],
  );

  useEffect(() => {
    if (url) {
      loadIcon(url);
    }
  }, [url, loadIcon]);

  return <div className={`${styles.icon} ${className}`.trim()} ref={svgRef}></div>;
};

export default Icon;
